import { render, staticRenderFns } from "./ot-create-document-associations.vue?vue&type=template&id=2bbb3ed2&scoped=true&"
import script from "./ot-create-document-associations.vue?vue&type=script&lang=ts&"
export * from "./ot-create-document-associations.vue?vue&type=script&lang=ts&"
import style0 from "./ot-create-document-associations.vue?vue&type=style&index=0&id=2bbb3ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb3ed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAlert,VForm,VMenu})
